<ion-header *ngIf="!displayModalNEPH && !displayModalNEPHInfos && !displayModalCategPermisChanged">
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content class="code-exam-reservation" [ngClass]="{'bg-page': (!initPageDone), 'background-white': initPageDone}">
  <!-- <page-loader-comp *ngIf="!longLoading && !initPageDone"></page-loader-comp> -->

  <!-- <bloc-header-comp
    [compOptions]="{
      'title': blocHeaderTitle,
      'mobile': false,
      'loading': !initPageDone,
      'isBackBtn': true,
      'url': 'conduite'
    }"
  >
  </bloc-header-comp> -->

  <div class="code-exam-reservation-content" *ngIf="initPageDone">
    <div *ngIf="true" class="top-progress-bar">
      <div class="circle-btn" (click)="changeStep('prev')">
        <img src="assets/2022/icons/arrow-left-white.svg" alt="EnVoitureSimone">
      </div>
      <div class="steps-bar">
        <div class="inner-bar" [style.width.%]="codeExamReservationPercentCompletion"></div>
      </div>
    </div>

    <div class="steps-wrapper max-width-700" [ngClass]="{'max-width-700': !(!isDesktop && codeExamReservationCurrentStep === 3), 'full-screen': !isDesktop && codeExamReservationCurrentStep === 3}">

      <div *ngIf="codeExamReservationCurrentStep === 1" class="step-container">
        <ion-spinner class="loading-spinner" *ngIf="loadingExamCenters" name="circles"></ion-spinner>
        <h4 *ngIf="isDesktop">Réserver mon<span class="exam-scribble"> examen </span>du code de la route</h4>
        <h5 class="with-spinner" *ngIf="!isDesktop">Réserver mon<span class="exam-scribble"> examen </span>du code de la route</h5>
        <form class="evs-form">
          <div>
            <autocomplete-local-comp *ngIf="showAutocompletes" id="postalCode" [compOptions]="{'id': 'postalCode', 'service': postalCodeService, 'fields': ['pc_value', 'name', 'pc_id', 'prefecture_id'], 'fieldname': 'name', 'output': 'prefecture_id', 'placeholder': 'Rechercher un code postal...'}" (inputSelected)="selectPostalCode($event)"></autocomplete-local-comp>
          </div>
        </form>
      </div>
  
      <div *ngIf="codeExamReservationCurrentStep === 2" class="step-container">
        <h4 *ngIf="isDesktop">Choisir mon centre<span class="exam-center-scribble"> d'examen </span></h4>
        <h5 *ngIf="!isDesktop">Choisir mon centre<span class="exam-center-scribble"> d'examen </span></h5>
        <div *ngIf="examCenters.length > 0" class="exam-centers-wrapper">
          <ng-container *ngFor="let examCenter of examCenters">
            <div class="evs-card small-clickable exam-center-card" (click)="selectExamCenter(examCenter)">
              <div class="exam-center-infos-wrapper">
                <img [src]="'assets/2022/pictos/centre_code.svg'" alt="EnvoitureSimone">
                <div class="exam-center-infos">
                  <h6>{{examCenter.site_name}}</h6>
                  <p>{{examCenter.address}}<br>{{examCenter.zipcode}} {{examCenter.city}}</p>
                </div>
              </div>
              <div class="exam-center-dispo-wrapper">
                <p *ngIf="loadingExamCenterSessions || (!loadingExamCenterSessions && !!examCenter.first_session && examCenter.first_session !== 'error')" class="next-date-label">Prochaine disponibilité</p>
                <ion-spinner *ngIf="loadingExamCenterSessions" name="circles"></ion-spinner>
                <p *ngIf="!loadingExamCenterSessions && !!examCenter.first_session && examCenter.first_session !== 'error'" class="next-date">{{examCenter.first_session}}</p>
                <p *ngIf="!loadingExamCenterSessions && !!examCenter.first_session && examCenter.first_session === 'error'" class="next-date">Une erreur est survenue</p>
                <p *ngIf="!loadingExamCenterSessions && !examCenter.first_session" class="next-date">Aucune disponibilité</p>
              </div>
            </div>
          </ng-container> 
        </div>

        <div *ngIf="examCenters.length === 0" class="exam-centers-wrapper">
          <p class="no-exam-center">Aucun centre n'a été trouvé, réessaie plus tard.</p>
        </div>
      </div>
  
      <div *ngIf="codeExamReservationCurrentStep === 3" class="step-container">
        <div #gMap class="gmap" [ngClass]="{'browser': !isCordova}"></div>
        <div class="exam-center-infos-wrapper-map">
          <img [src]="'assets/2022/pictos/centre_code.svg'" alt="EnvoitureSimone">
          <div class="exam-center-infos">
            <h4 *ngIf="isDesktop">{{selectedExamCenter.site_name}}</h4>
            <h6 *ngIf="!isDesktop">{{selectedExamCenter.site_name}}</h6>
            <p>{{selectedExamCenter.address}}<br>{{selectedExamCenter.zipcode}} {{selectedExamCenter.city}}</p>
          </div>
        </div>
        <button class="btn full-width map-button" (click)="changeStep('next')">Confirmer ce centre</button>
      </div>
  
      <div *ngIf="codeExamReservationCurrentStep === 4" class="step-container">
        <calendar-code-exam-reservation [compOptions]="{'sessions': selectedExamCenter.sessions}" (selectSession)="selectSession($event)"></calendar-code-exam-reservation>
      </div>
  
      <div *ngIf="codeExamReservationCurrentStep === 5" class="step-container">
        <ng-container *ngIf="!registrationCertificate && formsConstructed">
          <h4 *ngIf="isDesktop">Renseigner mon NEPH<span class="neph-scribble"></span></h4>
          <h5 *ngIf="!isDesktop">Renseigner mon NEPH<span class="neph-scribble"></span></h5>
          <div class="neph-infos">
            <h6>Le NEPH ? On t'explique ce que c'est !</h6>
            <p>Le NEPH (Numéro d'Enregistrement Préfectoral Harmonisé) est obligatoire pour passer l'examen du code de la route et du permis de conduire. Son obtention peut prendre entre 2 à 4 semaines. <span class="highlight-orange small-clickable" (click)="openModalNEPHInfos()">En savoir plus</span></p>
          </div>
          <form class="evs-form" [formGroup]="registrationCertificateForm" autocomplete="off" (ngSubmit)="submitRegistrationCertificateForm(registrationCertificateForm.value)">
            <div>
              <input type="text" formControlName="firstName" id="registrationCertificatePrenom" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificatePrenom" [ngClass]="{'label-up': !!getRegistrationCertificateForm.firstName.value && getRegistrationCertificateForm.firstName.value !== ''}">Premier prénom uniquement</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.firstName}"></ng-container>
            <p class="field-indicator">
              Comme inscrit sur ton <span class="highlight-orange small-clickable" (click)="openModalNEPH()">document officiel</span>, ponctuation et accents compris
            </p>

            <div>
              <input type="text" formControlName="lastName" id="registrationCertificateNom" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificateNom" [ngClass]="{'label-up': !!getRegistrationCertificateForm.lastName.value && getRegistrationCertificateForm.lastName.value !== ''}">Nom de famille</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.lastName}"></ng-container>
            <p class="field-indicator">
              Comme inscrit sur ton <span class="highlight-orange small-clickable" (click)="openModalNEPH()">document officiel</span>, ponctuation et accents compris
            </p>

            <div>
              <autocomplete-local-comp *ngIf="showAutocompletes" [compOptions]="{type: 'select', 'placeholder': 'Sexe', 'fields': ['name'], 'fieldname': 'name', 'output': 'value', value: student?.gender, selectData: genderList}" (inputSelected)="getAutocompleteSelectValue(registrationCertificateForm, 'gender', $event)"></autocomplete-local-comp>
            </div>

            <div>
              <input type="date" formControlName="birthdate" id="registrationCertificateBirthdate" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificateBirthdate" class="label-up">Date de naissance</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.birthdate}"></ng-container>

            <div>
              <input type="text" formControlName="NEPHNumber" id="registrationCertificateNEPH" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificateNEPH" [ngClass]="{'label-up': !!getRegistrationCertificateForm.NEPHNumber.value && getRegistrationCertificateForm.NEPHNumber.value !== ''}">Numéro NEPH</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.NEPHNumber}"></ng-container>
            <p class="field-indicator">
              Numéro à 12 chiffres. <span class="highlight-orange small-clickable" (click)="openModalNEPH()">Où le trouver&nbsp;?</span>
            </p>

            <div>
              <autocomplete-local-comp *ngIf="showAutocompletes" [compOptions]="{type: 'select', 'placeholder': 'Catégorie de permis', 'fields': ['name'], 'fieldname': 'name', 'output': 'value', value: 'Permis B', selectData: licenseList}" (inputSelected)="getAutocompleteSelectValue(registrationCertificateForm, 'license', $event)"></autocomplete-local-comp>
            </div>

            <div *ngIf="(registrationCertificateForm.touched || !registrationCertificateForm.pristine) && !!showRegistrationCertificateFormErrors && !registrationCertificateForm.valid" class="margin-top-20 margin-bottom-20 text-center text-warning">
              <span class="animated fadeIn">
                Nous n'avons pu enregistrer tes informations
                <br>car certains champs sont invalides
              </span>
            </div>
            <loading-button-comp class="wpe-100" [compOptions]="{loading: isRegistrationCertificateFormUploading, type: 'submit', valid: registrationCertificateForm.valid, disabled: !registrationCertificateForm.valid, spinnerColor: 'text-white', text: 'Envoyer'}" (hasClicked)="handleClick($event)"></loading-button-comp>
          </form>
        </ng-container>
        <ng-container *ngIf="registrationCertificate">
          <h4 *ngIf="isDesktop">Réservation impossible</h4>
          <h5 *ngIf="!isDesktop">Réservation impossible</h5>
          <p>Nous sommes navrés, mais tu dois avoir 16 ans révolus pour pouvoir passer ton examen.</p>
          <p>S’il s’agit d’une erreur, tu peux mettre à jour ton profil ou contacter notre équipe.</p>
        </ng-container>
      </div>
  
      <div *ngIf="codeExamReservationCurrentStep === 6" class="step-container">
        <h4 *ngIf="isDesktop">Renseigner mon <span class="phone-scribble">téléphone</span></h4>
        <h5 *ngIf="!isDesktop">Renseigner mon <span class="phone-scribble">téléphone</span></h5>
        <p>Nous t'enverrons un rappel par SMS la veille de ton examen 😊</p>
        <form *ngIf="formsConstructed" [formGroup]="userPhoneForm" autocomplete="off" class="evs-form" (ngSubmit)="submitUserPhoneForm(userPhoneForm.value)">
          <div>
            <input type="tel" formControlName="phoneNumber" id="profilTel" autocomplete="off" data-lpignore="true">
            <label for="profiltel" [ngClass]="{'label-up': !!getUserPhoneForm.phoneNumber.value && getUserPhoneForm.phoneNumber.value !== ''}">Téléphone</label>
          </div>
          <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getUserPhoneForm.phoneNumber}"></ng-container>
          <div *ngIf="userPhoneForm.touched || !userPhoneForm.pristine" class="margin-top-20 margin-bottom-20 text-center text-warning">
            <span *ngIf="!!showFormErrors && !userPhoneForm.valid" class="animated fadeIn">
              Nous n'avons pu enregistrer tes informations
              <br>car certains champs sont invalides
            </span>
          </div>
          <loading-button-comp class="wpe-100" [compOptions]="{loading: isUserPhoneFormUploading, type: 'submit', valid: userPhoneForm.valid, disabled: !userPhoneForm.valid, spinnerColor: 'text-white'}" (hasClicked)="handleClick($event)"></loading-button-comp>
        </form>
      </div>
  
      <div *ngIf="codeExamReservationCurrentStep === 7" class="step-container">
        <div class="reservation-recap">
          <h5>{{selectedSession.formattedDate}}</h5>
          <h4>{{selectedSession.formattedHour}}</h4>
          <h6>{{selectedExamCenter.site_name}}</h6>
          <p>{{selectedExamCenter.address}}<br>{{selectedExamCenter.zipcode}} {{selectedExamCenter.city}}</p>
        </div>
        <div *ngIf="!student?.creditStocks?.codeExam?.quantity || student?.creditStocks?.codeExam?.quantity === 0" class="reservation-recap-infos">
          <h6>Frais d’inscription</h6>
          <p>Pour finaliser ton inscription, tu dois régler des frais d’inscription à l’examen de 30€. Ce tarif fixé par l’État est demandé à tous les candidats.</p>
        </div>
        <loading-button-comp *ngIf="student?.creditStocks?.codeExam?.quantity > 0" class="wpe-100" [compOptions]="{loading: isCodeExamReservationProceeding, type: 'button', valid: true, disabled: false, spinnerColor: 'text-white', text: 'Valider'}" (click)="validateReservation('next')"></loading-button-comp>
        <loading-button-comp *ngIf="!student?.creditStocks?.codeExam?.quantity || student?.creditStocks?.codeExam?.quantity === 0" class="wpe-100" [compOptions]="{loading: isCodeExamReservationProceeding, type: 'button', valid: true, disabled: false, spinnerColor: 'text-white', text: 'Valider et payer'}" (click)="validateReservation('pay')"></loading-button-comp>
      </div>
  
      <div *ngIf="codeExamReservationCurrentStep === 8" class="step-container final-step">
        <ng-container *ngIf="reservationSuccessful">
          <img [src]="'assets/2022/illustrations/reservation_ok.svg'" alt="EnvoitureSimone">
          <h4 *ngIf="isDesktop">Ton examen est<span class="success-scribble">&nbsp;réservé&nbsp;</span></h4>
          <h5 *ngIf="!isDesktop">Ton examen est<span class="success-scribble">&nbsp;réservé&nbsp;</span></h5>
          <p>On croise les doigts pour toi 🤞</p>
          <p>Tu retrouveras ta convocation dans ton espace Code.</p>
          <button class="btn full-width" (click)="openLink('code')">Suivant</button>
        </ng-container>
        <ng-container *ngIf="!reservationSuccessful && !reservationErrorType">
          <img [src]="'assets/2022/illustrations/reservation_error.svg'" alt="EnvoitureSimone">
          <h4 *ngIf="isDesktop">Échec de la <span class="error-scribble">réservation</span></h4>
          <h5 *ngIf="!isDesktop">Échec de la <span class="error-scribble">réservation</span></h5>
          <p>Le créneau d'examen initialement choisi n'est plus disponible et nous n'avons donc pas pu réserver ton examen.<br>Tu peux choisir directement un nouveau créneau en cliquant ci-dessous. Rassure-toi, tu n'auras pas besoin de payer à nouveau ta place d'examen.</p>
          <button class="btn full-width" (click)="resetCodeExamReservation()">Réessayer</button>
        </ng-container>
        <ng-container *ngIf="!reservationSuccessful && !!reservationErrorType && reservationErrorType === 'poste_unavailable'">
          <img [src]="'assets/2022/illustrations/reservation_error.svg'" alt="EnvoitureSimone">
          <h4 *ngIf="isDesktop">Maintenance en cours chez <span class="error-scribble">La Poste</span></h4>
          <h5 *ngIf="!isDesktop">Maintenance en cours chez <span class="error-scribble">La Poste</span></h5>
          <p>Le service de réservation des examens du code La Poste effectue une maintenance et il n’est actuellement pas possible de réserver une date d’examen. Ne t'inquiètes pas, ton paiement lui a bien été validé !</p>
          <p>Nous t'invitons à réessayer un peu plus tard de réserver ta date d’examen. En attendant, pourquoi ne pas profiter de ce temps pour réviser ton code ?</p>
          <button class="btn full-width" (click)="resetCodeExamReservationAndRedirect('code')">Réviser le code</button>
        </ng-container>
        <ng-container *ngIf="!reservationSuccessful && !!reservationErrorType && reservationErrorType === 'neph_error'">
          <img [src]="'assets/2022/illustrations/reservation_error.svg'" alt="EnvoitureSimone">
          <h4 *ngIf="isDesktop">Ton code de la route a expiré (plus de 5 ans)</h4>
          <h5 *ngIf="!isDesktop">Ton code de la route a expiré (plus de 5 ans)</h5>
          <p>Tu dois réactiver ton NEPH auprès du service des permis de conduire de ton département !</p>
          <button class="btn full-width" (click)="resetCodeExamReservationAndRedirect('lostNEPH')">Continuer</button>
        </ng-container>
        <ng-container *ngIf="!reservationSuccessful && !!reservationErrorType && reservationErrorType === 'neph_form_error'">
          <img [src]="'assets/2022/illustrations/reservation_error.svg'" alt="EnvoitureSimone">
          <h4 *ngIf="isDesktop">Oups</h4>
          <h5 *ngIf="!isDesktop">Oups</h5>
          <p>Les informations saisies au niveau de ton NEPH semblent contenir des erreurs. Vérifie que les informations renseignées sont correctes.</p>
          <p>Si le problème persiste, contacte le service client.</p>
          <button class="btn full-width" (click)="openLink('supportNewRequest')">Contacter le service client</button>
        </ng-container>
      </div>
    </div>
    <!-- RGPD -->
    <p *ngIf="codeExamReservationCurrentStep === 1" class="rgpd-text">Pour en savoir plus sur la gestion de tes données personnelles <a class="rgpd-link" href="https://www.envoituresimone.com/politique-confidentialite">consulte notre politique de confidentialité</a>.</p>
  </div>

  <!-------------------------->
  <!-- FORM TEMPLATE ERRORS -->
  <!-------------------------->
  <ng-template #errorTemplate let-field="field">
    <ng-container *ngIf="!field.valid && (field.dirty || field.touched)">
      <div class="field-error" *ngIf="field.errors?.required">Ce champ est obligatoire</div>
      <div class="field-error" *ngIf="field.errors?.pattern">Ce champ n'est pas valide</div>
      <div class="field-error" *ngIf="field.errors?.minlength">Doit contenir au moins 6 caractères</div>
      <div class="field-error" *ngIf="field.errors?.maxlength">Nombre de caractères maximum dépassé</div>
      <div class="field-error" *ngIf="field.errors?.validatePasswords">Les mots de passe ne correspondent pas</div>
      <!-- {{field.errors?.validatePasswords | json}} -->
    </ng-container>
  </ng-template>

  <modal-comp [compOptions]="{'id': 'customModalUpload1', size: 'small'}" *ngIf="showModal1" (canClose)="hideModal1()">
    <div class="text-center margin-top-16">{{errorMsg}}</div>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalError', dynamicHeight: true}" *ngIf="!!showModalErrorServer" (canClose)="hideModalErrorServer()">
    <div class="text-center">
      <h4 class="margin-bottom-25">Oups !</h4>
      <ng-container *ngIf="showModalErrorServerText != 'duplicateNEPHCase'">
        <p>
          <span [innerHTML]="showModalErrorServerText"></span>
          <ng-container *ngIf="isDesktop"><br><br></ng-container>
          <ng-container *ngIf="!isDesktop"><br></ng-container>
          Pour remettre tout en ordre, direction notre FAQ où un <a class="link" (click)="openLink('nephReject')">article</a> t'attend avec toutes les étapes à suivre.
        </p>
        <button class="btn full-width margin-top-15" (click)="hideModalErrorServer()">Essayer à nouveau</button>
      </ng-container>

      <ng-container *ngIf="showModalErrorServerText === 'duplicateNEPHCase'">
        <p>
          Le <span class="bold">numéro NEPH</span> renseigné semble être enregistré sur un autre compte.
          <br><br>
          Afin de tout mettre en ordre, contacte le service client !
        </p>
        <button class="btn full-width margin-top-15" (click)="openLink('supportNewRequest')">Contacter le service client</button>
      </ng-container>
    </div>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalNEPH', 'size': 'full', closable: false}" *ngIf="displayModalNEPH" (canClose)="hideModalNEPH()" #modalNEPH>
    <h4>Attestation d'inscription ou cerfa 02 (dans l'étape Renseigner mon NEPH)</h4>
    <p>Quand tu t'inscris à une formation du permis de conduire, tu obtiens un numéro de candidat : LE NEPH. Ce numéro est inscrit sur ce qu'on appelle un cerfa 02 ou une attestation d'inscription.<br>
      Si tu as été inscrit en auto-école avant l'année 2017, tu possèdes un cerfa 02 :</p>
    <img [src]="'assets/png/student-documents/neph-cerfa.png'">
    <p>Si tu as été inscrit après l’année 2017, tu possèdes une attestation d’inscription :</p>
    <img [src]="'assets/png/student-documents/neph-registration-certificate.png'">
    <button class="btn full-width" (click)="callHideModalNEPH()">Fermer</button>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalCategPermisChanged', closable: false}" *ngIf="displayModalCategPermisChanged" (canClose)="hideModalCategPermisChanged()" #modalCategPermisChanged>
    <h4>Attention&nbsp;!</h4>
    <p>Tu as indiqué une catégorie différente de la catégorie B (permis voiture classique).<br><br>
      Tu pourras t'inscrire à l’examen du code de la route sans problème. Cependant, il ne sera pas possible d’effectuer des heures de conduite avec notre auto-école car nous dispensons uniquement des leçons pour le permis B.<br><br>
      Si tu penses que c’est une erreur, tu peux contacter notre <span class="indicator-modale" (click)="openLink('supportNewRequest')">service client</span> pour trouver une solution.</p>
    <button class="btn" (click)="callHideModalCategPermisChanged()">J'ai compris</button>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalNEPHInfos', closable: false}" *ngIf="displayModalNEPHInfos" (canClose)="hideModalNEPHInfos()" #modalNEPHInfos>
    <img class="small-clickable" [src]="'assets/2022/icons/close-on.svg'" (click)="callHideModalNEPHInfos()">
    <h4>Comment obtenir mon NEPH&nbsp;?</h4>
    <p>Le NEPH est un identifiant (composé de 12 chiffres) délivré par la préfecture, nécessaire pour t'inscrire aux examens du code et du permis de conduire.</p>
    <p>Pour l'obtenir, tu devras t'inscrire sur le site de l'ANTS (Agence Nationale des Titres Sécurisés).<br>Prévois un délai de 2 à 4 semaines pour le recevoir. Découvre les étapes détaillées pour t'inscrire et obtenir ton NEPH dans notre article complet <a (click)="openLink('howNEPH')">ici</a>.</p>
    <button class="btn" [ngClass]="{'small': !isDesktop}" (click)="openLink('gouvNEPH')">M'inscrire sur le site de l'ANTS</button>
  </modal-comp>
</ion-content>

<ion-footer *ngIf="!displayModalNEPH && !displayModalNEPHInfos && !displayModalCategPermisChanged">
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>
